__turbopack_context__.v({
  "arrow": "LocationCard-module-scss-module__K9xYzq__arrow",
  "border-radius": "LocationCard-module-scss-module__K9xYzq__border-radius",
  "contact-information": "LocationCard-module-scss-module__K9xYzq__contact-information",
  "content": "LocationCard-module-scss-module__K9xYzq__content",
  "excerpt": "LocationCard-module-scss-module__K9xYzq__excerpt",
  "image-overlay": "LocationCard-module-scss-module__K9xYzq__image-overlay",
  "label": "LocationCard-module-scss-module__K9xYzq__label",
  "main": "LocationCard-module-scss-module__K9xYzq__main",
  "phone": "LocationCard-module-scss-module__K9xYzq__phone",
  "row": "LocationCard-module-scss-module__K9xYzq__row",
});
